import { createContext } from 'react';

const CardDndContext = createContext(null);
export default CardDndContext;
